import * as Icons from "lucide-react";
import { Link } from "react-router-dom";
import { useData } from "@/context/DataContext";
import { Reveal, SectionHeader } from "@/components/shared/Reveal";

export const InfoSection = ({ heading = "Tävlingsinformation", kicker = "För förare & team" }) => {
  const { data } = useData();
  const sections = data.infosections || [];
  if (!sections.length) return null;

  return (
    <section data-testid="info-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <SectionHeader kicker={kicker} title={heading} />
        </Reveal>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {sections.map((s, i) => {
            const Icon = Icons[toPascal(s.icon)] || Icons.Info;
            return (
              <Reveal key={s.id} delay={i * 0.05}>
                <div className="group h-full rounded-xl bg-[#14161A] border border-white/8 p-6 hover-lift hover:border-amber-500/40">
                  <div className="inline-flex p-3 rounded-lg bg-amber-500/10 border border-amber-500/20 text-amber-500">
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="mt-4 font-display text-2xl font-bold uppercase text-white">{s.heading}</h3>
                  <p className="mt-2 text-sm text-white/60 leading-relaxed whitespace-pre-line">{s.body?.includes("via Depåbokning") ? <>{s.body.split("Depåbokning")[0]}<Link to="/depa-bokning" data-testid="info-depa-link" className="text-amber-500 hover:underline">Depåbokning</Link>{s.body.split("Depåbokning").slice(1).join("Depåbokning")}</> : s.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

function toPascal(str) {
  if (!str) return "Info";
  return str.split("-").map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join("");
}
